import { vehicleSelected } from 'Core/actions/fitmentSearch/index';
import { type EpicArg, epicFromHandlers } from 'Core/epics/common';
import { selectedVehicleSelector } from 'Core/selectors/fitmentSearch/index';
import { Vehicle } from 'Models/index';

export default epicFromHandlers(
  {
    [vehicleSelected.type]: handleKlaviyo,
  },
  'klaviyo',
);

async function handleKlaviyo({ state, action: { payload } }: EpicArg) {
  const selectedVehicle = payload instanceof Vehicle ? payload : selectedVehicleSelector(state);

  if (window.klaviyo && selectedVehicle.notNull) {
    const vehicleMap = Object.fromEntries(selectedVehicle.selection.map((v) => [v.field, v.value]));
    window.klaviyo.push(['identify', vehicleMap]);
    window.klaviyo.push(['track', 'Vehicle Selected', vehicleMap]);
  }
}
